import React from 'react';
import TablePage from '../../../../../components/pages/TablePage';
import moment from 'moment';

export default () => {
    const columns = [
        {
            selector: (row) => row?.pjt_id?.name,
            name: "PJT",
            id: 'pjt'
        },
        {
            selector: (row) => row?.name,
            name: "Name",
            id: 'name'
        },
        {
            selector: (row) => row?.username,
            name: "Username",
            id: 'username'
        },
        {
            selector: (row) => (row?.createdAt && moment(row.createdAt).format('DD-MMM-YYYY')) || '-',
            name: "Created",
            id: 'created_at'
        },
    ]
    return (
        <TablePage
            title={"Master Users PJT"}
            url="api/v1/user_pjt"
            actionPosition={'first'}
            createPath="/master/user_pjt/create"
            editPath={"/master/user_pjt/edit"}
            columns={columns}
        />
    )
}